export const decodeBase64Html = (text: string): string => {
  const base64Prefix = 'data:image/png;base64,';
  if (text.startsWith(base64Prefix)) {
    const base64Content = text.slice(base64Prefix.length);
    return atob(base64Content);
  }
  return text;
};
